import React, { useEffect, useState, useRef, useLayoutEffect } from 'react';

import cn from 'classnames';

import * as ScrollMagic from 'scrollmagic';
import { ScrollMagicPluginIndicator, ScrollMagicPluginGsap } from 'scrollmagic-plugins';
import { TweenMax, TimelineMax } from 'gsap';
import './home.scss';
import MagicContainer from '../../components/magicContainer';
import GsapContainer from '../../components/gsapContainer';

import FirstScreen from '../../components/firstScreen';
// import FirstScreen from "../../components/firstScreenTest";
import One from '../../milestones/one/one';
import Two from '../../milestones/two/two';
import Three from '../../milestones/three/three';
import Header from '../../components/header/header';

ScrollMagicPluginIndicator(ScrollMagic);
ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
const controller = new ScrollMagic.Controller();

function Home(props) {
  const {} = props;

  const [firstScreen, setFirstScreen] = useState(true);

  const [one, setOne] = useState(false);

  const [two, setTwo] = useState(false);

  const [three, setThree] = useState(false);
  const [currentScroll, setCurrentScroll] = useState(0);

  const [currentDate, setCurrentDate] = useState(null);
  const [anchor, setAnchor] = useState(null);

  const setSection = ({ section, status }) => {
    console.log('firstScreen: ', firstScreen);
    console.log('one: ', one);
    console.log('two: ', two);
    
    if (section === 'firstScreen' && !status) {
      setFirstScreen(false);
      setAnchor(null)
      setOne(true);
    }

    if (section === 'tmHz' && !status) {
      console.log("end2");
      setFirstScreen(true);
      setOne(false);
      setCurrentScroll(3200);
    }

    if (section === 'one' && !status) {
      setFirstScreen(false);
      setOne(false);
      setTwo(true);
      setThree(false);
    }

    
    if (section === 'two' && !status) {
      setFirstScreen(false);
      setOne(false);
      setTwo(false);
      setThree(true);
    }
  };

  useEffect(() => {

    if (currentDate && currentDate.years) {
      console.log("date", currentDate);
      
      if (currentDate.years === 1) {
        console.log("222");
            
        setTimeout(() => {
          hideSection();

          setCurrentScroll(3200);
          setFirstScreen(true);
        },200)

      }

      if (currentDate.years >= 2007 && currentDate.years <= 2011) {
  
        setTimeout(() => {

          if (!one) {

            console.log('one: ', one);

            hideSection();
            setOne(true);
          }
        }, 200)
      } else if (currentDate.years >= 2012 && currentDate.years <= 2016) {
       
        setTimeout(() => {
          if (!two) {
            console.log('two: ', two);

            hideSection();
            setTwo(true);
          }
        }, 200)
      } else if (currentDate.years >= 2017 && currentDate.years <= 2022) {
        setTimeout(() => {
          if (!three) {
            console.log('three anchors: ', three);
            
            hideSection();
            setThree(true);
          }

        }, 200)
      }

      function hideSection() {
        setFirstScreen(false);
        setOne(false);
        setTwo(false);
        setThree(false);
      }

      setAnchor(currentDate);

    }

  },[currentDate])
  return (
    <>
      <main className="page">
        {firstScreen && <FirstScreen setSection={setSection} scroll={currentScroll} setCurrentDate={setCurrentDate} anchor={anchor} />}
        {one && <One setSection={setSection} status={one} setCurrentDate={setCurrentDate} anchor={anchor} />}
        {two && <Two setSection={setSection} status={two} setCurrentDate={setCurrentDate} anchor={anchor} />}
        {three && <Three setSection={setSection} status={three} setCurrentDate={setCurrentDate} anchor={anchor}/>}
      </main>
    </>
  );
}

export default Home;
